import { SVGProps } from 'react'

export const EventrLogo = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="32"
        height="32"
        viewBox="0 0 168 168"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M36 56C47.0457 56 56 47.0457 56 36C56 24.9543 47.0457 16 36 16C24.9543 16 16 24.9543 16 36C16 47.0457 24.9543 56 36 56Z"
            fill="#18B1AB"
        />
        <path
            d="M84 56C95.0457 56 104 47.0457 104 36C104 24.9543 95.0457 16 84 16C72.9543 16 64 24.9543 64 36C64 47.0457 72.9543 56 84 56Z"
            fill="#A53AB6"
        />
        <path
            d="M132 56C143.046 56 152 47.0457 152 36C152 24.9543 143.046 16 132 16C120.954 16 112 24.9543 112 36C112 47.0457 120.954 56 132 56Z"
            fill="#18B1AB"
        />
        <path
            d="M36 104C47.0457 104 56 95.0457 56 84C56 72.9543 47.0457 64 36 64C24.9543 64 16 72.9543 16 84C16 95.0457 24.9543 104 36 104Z"
            fill="#0A1F41"
        />
        <path
            d="M84 104C95.0457 104 104 95.0457 104 84C104 72.9543 95.0457 64 84 64C72.9543 64 64 72.9543 64 84C64 95.0457 72.9543 104 84 104Z"
            fill="#FF565C"
        />
        <path
            d="M132 104C143.046 104 152 95.0457 152 84C152 72.9543 143.046 64 132 64C120.954 64 112 72.9543 112 84C112 95.0457 120.954 104 132 104Z"
            fill="#FFC900"
        />
        <path
            d="M36 152C47.0457 152 56 143.046 56 132C56 120.954 47.0457 112 36 112C24.9543 112 16 120.954 16 132C16 143.046 24.9543 152 36 152Z"
            fill="#18B1AB"
        />
        <path
            d="M84 152C95.0457 152 104 143.046 104 132C104 120.954 95.0457 112 84 112C72.9543 112 64 120.954 64 132C64 143.046 72.9543 152 84 152Z"
            fill="#A53AB6"
        />
        <path
            d="M132 152C143.046 152 152 143.046 152 132C152 120.954 143.046 112 132 112C120.954 112 112 120.954 112 132C112 143.046 120.954 152 132 152Z"
            fill="#18B1AB"
        />
    </svg>
)
